/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable object-curly-newline */
/* eslint-disable indent */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useMemo } from 'react';
import moment from 'moment';
import {
  IconButton, Typography, Button, Checkbox,
  Dialog, DialogContent, DialogActions,
  Menu, MenuItem, ListItemIcon, ListItemText, CircularProgress, TextField, Tooltip,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import { useSelector } from 'react-redux';
import type { Cell } from 'react-table';
import CustomTable from 'shared-components/tables/CustomTable';
import StradaSearch from 'admin/buildingSection/budget-calendar/components/StradaSearch';
import type { IDataObject } from 'formsTypes';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useSnackbar } from 'notistack';
import CustomLoader from 'shared-components/components/CustomLoader';
import axios from 'axios';
import type { AxiosResponse } from 'axios';
import type { RootState } from 'mainStore';
import { useNavigate } from 'react-router-dom';
import type { LeaseListItem, LeaseDetail } from './types';
import LeaseDetailSideSheet from './LeaseDetailSideSheet';
import UploadDialog from './UploadDialog';
import './_Leases.scss';

const formatDate = (dateStr: string | null): string => {
  if (!dateStr) return '—';
  return moment(dateStr).format('MMM D, YYYY');
};

// Suite cell with self-owned draft state. Keeping the input value in this
// component prevents the parent `columns` useMemo from recomputing on every
// keystroke (which would remount the TextField and cause caret-jump / lag).
interface SuiteEditCellProps {
  initialValue: string;
  onSave: (value: string) => void;
  onCancel: () => void;
}
function SuiteEditCell({ initialValue, onSave, onCancel }: SuiteEditCellProps): JSX.Element {
  const [value, setValue] = useState<string>(initialValue);
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
      onClick={(e): void => { e.stopPropagation(); }}
      aria-hidden='true'
    >
      <TextField
        size='small'
        value={value}
        onChange={(e): void => { setValue(e.target.value); }}
        onKeyDown={(e): void => {
          if (e.key === 'Enter') onSave(value);
          else if (e.key === 'Escape') onCancel();
        }}
        onBlur={(): void => { onSave(value); }}
        autoFocus
        placeholder='Enter suite'
        sx={{
          flex: 1,
          maxWidth: '110px',
          '& .MuiInputBase-input': { fontSize: '13px', padding: '4px 8px' },
          '& .MuiOutlinedInput-root': { borderRadius: '4px' },
        }}
      />
      <IconButton size='small' onClick={(): void => { onSave(value); }} sx={{ color: '#00CFA1', p: '2px' }}>
        <CheckIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </div>
  );
}

export default function LeasesContent(): JSX.Element {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [search, setSearch] = useState<string>('');
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  // Sidesheet state
  const [showSidesheet, setShowSidesheet] = useState<boolean>(false);
  const [isClosing, setIsClosing] = useState<boolean>(false);
  const [selectedLease, setSelectedLease] = useState<LeaseListItem | null>(null);

  // Delete dialog
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<LeaseListItem | null>(null);

  // Bulk delete state
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());
  const [bulkDeleteDialogOpen, setBulkDeleteDialogOpen] = useState<boolean>(false);

  // Actions menu
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const [menuItem, setMenuItem] = useState<LeaseListItem | null>(null);

  // Inline editing for unit/suite
  // Only the row id is tracked at this level — the draft value lives inside
  // SuiteEditCell so typing doesn't invalidate the columns memo.
  const [editingUnitSuiteId, setEditingUnitSuiteId] = useState<number | null>(null);

  const currentWorkspace = useSelector(
    (state: RootState) => state.workspaces.currentWorkspace.currentWorkspace,
  );

  // Fetch leases
  const {
    data: leasesData,
    isLoading,
  } = useQuery(
    ['get/leases', currentWorkspace.id, search],
    async () => axios({
      url: 'api/leases/',
      method: 'get',
      params: {
        workspace: currentWorkspace.id,
        search,
      },
    }),
    {
      enabled: Boolean(currentWorkspace.id),
      // Poll every 5s while any lease is processing (e.g. amendment upload in
      // progress) so the row spinner updates promptly, otherwise every 30s.
      refetchInterval: (data) => {
        const anyProcessing = data?.some((l) => l.is_processing);
        return anyProcessing ? 5000 : 30000;
      },
      select: (res: AxiosResponse) => res.data.data as LeaseListItem[],
    },
  );

  // Upload mutation
  const { mutate: uploadLease, isLoading: isUploading } = useMutation(
    async (file: File) => {
      const formData = new FormData();
      formData.append('pdf', file);
      formData.append('workspace', String(currentWorkspace.id));
      return axios({
        url: 'api/leases/',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    {
      onSuccess: async (res: AxiosResponse) => {
        await queryClient.invalidateQueries('get/leases');
        const uploaded = res.data.data as LeaseListItem;
        enqueueSnackbar(uploaded.processing_status === 'awaiting_approval'
          ? 'Lease uploaded. The daily upload limit is reached, so it will be processed once Strada approves it'
          : 'Lease uploaded and processing started');
      },
      onError: () => {
        enqueueSnackbar('Failed to upload lease', { variant: 'error' });
      },
    },
  );

  // Delete mutation
  const { mutate: deleteLease } = useMutation(
    async (id: number) => axios({
      url: `api/leases/${id}/`,
      method: 'delete',
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/leases');
        enqueueSnackbar('Lease deleted successfully');
      },
      onError: () => {
        enqueueSnackbar('Failed to delete lease', { variant: 'error' });
      },
    },
  );

  // Bulk delete mutation
  const { mutate: bulkDeleteLeases, isLoading: isBulkDeleting } = useMutation(
    async (ids: number[]) => axios({
      url: 'api/leases/bulk_delete/',
      method: 'post',
      data: { ids },
    }),
    {
      onSuccess: async (res: AxiosResponse) => {
        await queryClient.invalidateQueries('get/leases');
        const count = res.data?.detail?.count ?? selectedIds.size;
        enqueueSnackbar(`${count} lease${count !== 1 ? 's' : ''} deleted`);
        setSelectedIds(new Set());
      },
      onError: () => {
        enqueueSnackbar('Failed to delete selected leases', { variant: 'error' });
      },
    },
  );

  // Update unit/suite mutation
  const { mutate: updateUnitSuite } = useMutation(
    async ({ id, unitSuite }: { id: number; unitSuite: string }) => axios({
      url: `api/leases/${id}/`,
      method: 'patch',
      data: { unit_suite: unitSuite },
    }),
    {
      onSuccess: () => {
        // Close the inline editor and confirm immediately; refetch in the
        // background so the field doesn't appear to hang. The table preserves
        // the user's sort across the update (autoResetSortBy is off).
        setEditingUnitSuiteId(null);
        enqueueSnackbar('Suite updated');
        queryClient.invalidateQueries('get/leases').catch(() => {});
        queryClient.invalidateQueries('get/options-monitor').catch(() => {});
      },
      onError: () => {
        enqueueSnackbar('Failed to update suite', { variant: 'error' });
        setEditingUnitSuiteId(null);
      },
    },
  );

  const handleUnitSuiteClick = (item: LeaseListItem): void => {
    setEditingUnitSuiteId(item.id);
  };

  const handleUnitSuiteSave = (id: number, value: string): void => {
    updateUnitSuite({ id, unitSuite: value });
  };

  const handleUnitSuiteCancel = (): void => {
    setEditingUnitSuiteId(null);
  };

  // Bulk selection helpers
  const selectableItems = useMemo(
    () => (leasesData || []).filter((item: LeaseListItem) => !item.is_processing),
    [leasesData],
  );

  const handleToggleSelect = (id: number): void => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const handleSelectAll = (): void => {
    if (selectedIds.size === selectableItems.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(selectableItems.map((item: LeaseListItem) => item.id)));
    }
  };

  // Sync selectedLease with fresh data
  React.useEffect(() => {
    if (selectedLease && leasesData) {
      const updated = leasesData.find((l: LeaseListItem) => l.id === selectedLease.id);
      if (updated && JSON.stringify(updated) !== JSON.stringify(selectedLease)) {
        setSelectedLease(updated);
      }
    }
  }, [leasesData, selectedLease]);

  const handleCloseSidesheet = (): void => {
    setIsClosing(true);
    setTimeout(() => {
      setShowSidesheet(false);
      setSelectedLease(null);
      setIsClosing(false);
    }, 250);
  };

  const handleOpenSidesheet = (item: LeaseListItem): void => {
    setSelectedLease(item);
    setShowSidesheet(true);
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <Checkbox
            checked={selectableItems.length > 0 && selectedIds.size === selectableItems.length}
            indeterminate={selectedIds.size > 0 && selectedIds.size < selectableItems.length}
            onChange={handleSelectAll}
            sx={{ p: 0, color: '#9CA3AF', '&.Mui-checked': { color: '#00CFA1' }, '&.MuiCheckbox-indeterminate': { color: '#00CFA1' } }}
            size='small'
          />
        ),
        accessor: 'select',
        width: '3%',
        disableSortBy: true,
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const item = cell.row.original as unknown as LeaseListItem;
          if (item.is_processing) return <div />;
          return (
            <Checkbox
              checked={selectedIds.has(item.id)}
              onChange={(e): void => { e.stopPropagation(); handleToggleSelect(item.id); }}
              onClick={(e): void => { e.stopPropagation(); }}
              sx={{ p: 0, color: '#9CA3AF', '&.Mui-checked': { color: '#00CFA1' } }}
              size='small'
            />
          );
        },
      },
      {
        Header: 'Building',
        accessor: 'building_name',
        width: '16%',
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value } = cell;
          return (
            <span style={{ color: value ? '#212121' : '#9E9E9E', fontStyle: value ? 'normal' : 'italic', fontSize: '13px', wordBreak: 'normal', overflowWrap: 'break-word' }}>
              {value || 'Unassigned'}
            </span>
          );
        },
      },
      {
        Header: 'Tenant',
        accessor: 'tenant_name',
        width: '18%',
        Cell: (cell: Cell<IDataObject>) => {
          const item = cell.row.original as unknown as LeaseListItem;
          if (item.is_processing) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <CircularProgress size={14} />
                <span style={{ color: '#6B7280', fontSize: '13px' }}>Processing...</span>
              </div>
            );
          }
          return (
            <span
              style={{
                color: '#00CFA1',
                fontWeight: 500,
                fontSize: '13px',
                cursor: 'pointer',
                wordBreak: 'keep-all',
                overflowWrap: 'break-word',
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenSidesheet(item);
              }}
              role='button'
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') handleOpenSidesheet(item); }}
            >
              {item.tenant_name || 'Unnamed Tenant'}
              {item.amendment_suggestion && (
                <Tooltip title={`Looks like an amendment for ${item.amendment_suggestion.target_tenant} — open to attach or dismiss`}>
                  <span
                    style={{
                      marginLeft: '8px',
                      backgroundColor: '#FFF3E0',
                      color: '#E65100',
                      fontSize: '11px',
                      fontWeight: 600,
                      padding: '2px 8px',
                      borderRadius: '4px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Possible amendment
                  </span>
                </Tooltip>
              )}
              {item.processing_status && (
                <Tooltip
                  title={item.processing_status === 'awaiting_approval'
                    ? 'Daily upload limit reached: the lease is saved and will be processed once Strada approves it'
                    : 'Strada declined processing this lease'}
                >
                  <span
                    style={{
                      marginLeft: '8px',
                      backgroundColor: item.processing_status === 'awaiting_approval' ? '#E3F2FD' : '#F3F4F6',
                      color: item.processing_status === 'awaiting_approval' ? '#1565C0' : '#6B7280',
                      fontSize: '11px',
                      fontWeight: 600,
                      padding: '2px 8px',
                      borderRadius: '4px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item.processing_status === 'awaiting_approval' ? 'Awaiting approval' : 'Not processed'}
                  </span>
                </Tooltip>
              )}
            </span>
          );
        },
      },
      {
        Header: 'Suite',
        accessor: 'unit_suite',
        width: '10%',
        Cell: (cell: Cell<IDataObject>) => {
          const item = cell.row.original as unknown as LeaseListItem;
          if (item.is_processing) return <span style={{ color: '#9CA3AF', fontSize: '13px' }}>—</span>;
          const isEditing = editingUnitSuiteId === item.id;
          if (isEditing) {
            return (
              <SuiteEditCell
                initialValue={item.unit_suite || ''}
                onSave={(value): void => { handleUnitSuiteSave(item.id, value); }}
                onCancel={handleUnitSuiteCancel}
              />
            );
          }
          return (
            <div
              style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
              onClick={(e): void => { e.stopPropagation(); handleUnitSuiteClick(item); }}
              aria-hidden='true'
            >
              <span style={{ color: item.unit_suite ? '#374151' : '#9CA3AF', fontSize: '13px', fontStyle: item.unit_suite ? 'normal' : 'italic' }}>
                {item.unit_suite || 'Click to add'}
              </span>
              <EditIcon style={{ fontSize: '12px', color: '#9CA3AF', opacity: 0.6 }} />
            </div>
          );
        },
      },
      {
        Header: 'Lease Start',
        accessor: 'lease_start_date',
        width: '12%',
        Cell: (cell: Cell<IDataObject>) => {
          const item = cell.row.original as unknown as LeaseListItem;
          return (
            <span style={{ color: '#374151', fontSize: '13px' }}>
              {formatDate(item.lease_start_date)}
            </span>
          );
        },
      },
      {
        Header: 'Current Expiration',
        accessor: 'lease_expiration_date',
        width: '12%',
        Cell: (cell: Cell<IDataObject>) => {
          const item = cell.row.original as unknown as LeaseListItem;
          return (
            <span style={{ color: '#374151', fontSize: '13px' }}>
              {formatDate(item.lease_expiration_date)}
            </span>
          );
        },
      },
      {
        Header: 'Options',
        accessor: 'has_options',
        width: '8%',
        Cell: (cell: Cell<IDataObject>) => {
          const item = cell.row.original as unknown as LeaseListItem;
          return (
            <span
              style={{
                fontSize: '12px',
                fontWeight: 500,
                padding: '2px 8px',
                borderRadius: '4px',
                backgroundColor: item.has_options ? '#E8F5E9' : '#F3F4F6',
                color: item.has_options ? '#2E7D32' : '#6B7280',
              }}
            >
              {item.has_options ? 'Yes' : 'No'}
            </span>
          );
        },
      },
      {
        Header: 'Amendments',
        accessor: 'amendment_count',
        width: '8%',
        Cell: (cell: Cell<IDataObject>) => {
          const item = cell.row.original as unknown as LeaseListItem;
          return (
            <span style={{ color: '#374151', fontSize: '13px' }}>
              {item.amendment_count}
            </span>
          );
        },
      },
      {
        Header: 'Last Updated',
        accessor: 'modified',
        width: '10%',
        Cell: (cell: Cell<IDataObject>) => {
          const item = cell.row.original as unknown as LeaseListItem;
          return (
            <span style={{ color: '#9CA3AF', fontSize: '12px' }}>
              {formatDate(item.modified)}
            </span>
          );
        },
      },
      {
        Header: '',
        accessor: 'actions',
        width: '6%',
        disableSortBy: true,
        Cell: (cell: Cell<IDataObject>) => {
          const item = cell.row.original as unknown as LeaseListItem;
          if (item.is_processing) return <span />;
          return (
            <IconButton
              size='small'
              onClick={(e) => {
                e.stopPropagation();
                setMenuAnchor(e.currentTarget);
                setMenuItem(item);
              }}
            >
              <MoreHorizIcon style={{ fontSize: '18px' }} />
            </IconButton>
          );
        },
      },
    ],
    [selectedIds, selectableItems, editingUnitSuiteId],
  );

  return (
    <>
      <div className='leases-wrapper'>
        {/* Header */}
        <div className='leases-header'>
          <div className='header-title-row'>
            <div>
              <Typography className='header-text'>Leases</Typography>
              <Typography variant='body2' color='textSecondary'>
                Manage lease documents, amendments, and key dates for your portfolio.
              </Typography>
            </div>
            <div className='header-actions'>
              <StradaSearch
                value={search}
                setSearch={setSearch}
                placeholder='Search tenants or buildings...'
              />
              <Button
              variant='contained'
              startIcon={<FileUploadIcon />}
              onClick={(): void => { navigate('/workspace/lease/upload/new'); }}
              sx={{
                backgroundColor: '#00CFA1',
                color: '#fff',
                textTransform: 'none',
                borderRadius: '6px',
                padding: '6px 16px',
                fontSize: '14px',
                fontWeight: 500,
                height: '35px',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: '#00b890',
                  boxShadow: 'none',
                },
              }}
            >
              Upload New
            </Button>
            </div>
          </div>
        </div>

        {/* Results count + bulk actions */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', gap: '12px', height: '36px' }}>
          <Typography className='results-count'>
            Showing {leasesData?.length ?? 0} leases
          </Typography>
          {selectedIds.size > 0 && (
            <>
              <span style={{ color: '#D1D5DB', fontSize: '14px' }}>|</span>
              <Typography style={{ fontSize: '14px', color: '#DC2626', fontWeight: 500 }}>
                {selectedIds.size}
                {' selected'}
              </Typography>
              <Button
                variant='contained'
                size='small'
                startIcon={<DeleteOutlineIcon />}
                onClick={(): void => { setBulkDeleteDialogOpen(true); }}
                disabled={isBulkDeleting}
                sx={{
                  backgroundColor: '#DC2626',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: 500,
                  height: '28px',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#B91C1C',
                    boxShadow: 'none',
                  },
                }}
              >
                {isBulkDeleting ? 'Deleting...' : `Delete Selected (${selectedIds.size})`}
              </Button>
              <Button
                variant='text'
                size='small'
                onClick={(): void => { setSelectedIds(new Set()); }}
                sx={{ color: '#6B7280', textTransform: 'none', fontSize: '13px' }}
              >
                Clear Selection
              </Button>
            </>
          )}
        </div>

        {/* Table */}
        {isLoading ? (
          <div style={{ height: '70vh' }} className='d-flex justify-content-center align-items-center'>
            <CustomLoader />
          </div>
        ) : (
          <div className='leases-table-container'>
            <CustomTable
              columns={columns}
              data={leasesData || []}
              onRowClick={(row: LeaseListItem): void => {
                if (row.is_processing) return;
                handleOpenSidesheet(row);
              }}
              selectedRowId={selectedLease?.id}
              getRowClassName={(row: LeaseListItem): string => {
                if (row.is_processing) return 'processing-row';
                return '';
              }}
            />
          </div>
        )}
      </div>

      {/* Backdrop overlay when sidesheet is open */}
      {showSidesheet && (
        <div
          className={`leases-sidesheet-backdrop${isClosing ? ' closing' : ''}`}
          onClick={handleCloseSidesheet}
          aria-hidden='true'
        />
      )}

      {/* Detail Sidesheet */}
      {showSidesheet && selectedLease && (
        <LeaseDetailSideSheet
          leaseId={selectedLease.id}
          workspaceId={currentWorkspace.id}
          isClosing={isClosing}
          onClose={handleCloseSidesheet}
          onRefresh={async (): Promise<void> => {
            await queryClient.invalidateQueries('get/leases');
          }}
        />
      )}

      {/* Upload Dialog */}
      <UploadDialog
        open={uploadDialogOpen}
        onClose={(): void => { setUploadDialogOpen(false); }}
        onUpload={(file: File): void => { uploadLease(file); }}
        title='Upload New Lease'
        subtitle='Select a PDF file of your lease agreement. It will be processed automatically.'
      />

      {/* Actions Menu */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={(): void => { setMenuAnchor(null); setMenuItem(null); }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={(): void => {
          if (menuItem) handleOpenSidesheet(menuItem);
          setMenuAnchor(null);
        }}>
          <ListItemIcon><OpenInNewIcon fontSize='small' /></ListItemIcon>
          <ListItemText>View Details</ListItemText>
        </MenuItem>
        <MenuItem onClick={(): void => {
          if (menuItem) {
            setItemToDelete(menuItem);
            setDeleteDialogOpen(true);
          }
          setMenuAnchor(null);
        }}>
          <ListItemIcon><DeleteOutlineIcon fontSize='small' style={{ color: '#DC2626' }} /></ListItemIcon>
          <ListItemText style={{ color: '#DC2626' }}>Delete</ListItemText>
        </MenuItem>
      </Menu>

      {/* Bulk Delete Confirmation Dialog */}
      <Dialog open={bulkDeleteDialogOpen} aria-labelledby='bulk-delete-dialog-title'>
        <DialogContent style={{ width: 400, padding: '24px' }}>
          <div style={{ fontSize: '18px', fontWeight: 500, marginBottom: '12px' }}>
            {'Delete '}
            {selectedIds.size}
            {' Lease'}
            {selectedIds.size !== 1 ? 's' : ''}
            ?
          </div>
          <span style={{ fontSize: '14px', color: 'rgba(33, 33, 33, 0.6)', fontWeight: '400' }}>
            {'Are you sure you want to delete '}
            <strong>
              {selectedIds.size}
            </strong>
            {' selected lease'}
            {selectedIds.size !== 1 ? 's' : ''}
            ? This action cannot be undone.
          </span>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <Button
            onClick={(): void => { setBulkDeleteDialogOpen(false); }}
            style={{ color: '#00CFA1', textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button
            onClick={(): void => {
              bulkDeleteLeases([...selectedIds]);
              setBulkDeleteDialogOpen(false);
            }}
            style={{ textTransform: 'none', color: 'white', background: '#DC2626' }}
            variant='contained'
            disabled={isBulkDeleting}
          >
            {isBulkDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} aria-labelledby='delete-dialog-title'>
        <DialogContent style={{ width: 400, padding: '24px' }}>
          <div style={{ fontSize: '18px', fontWeight: 500, marginBottom: '12px' }}>
            Delete Lease?
          </div>
          <span style={{ fontSize: '14px', color: 'rgba(33, 33, 33, 0.6)', fontWeight: '400' }}>
            Are you sure you want to delete this lease for
            {' '}
            <strong>{itemToDelete?.tenant_name}</strong>
            ? This will remove the lease and all associated documents.
          </span>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <Button
            onClick={(): void => { setDeleteDialogOpen(false); setItemToDelete(null); }}
            style={{ color: '#00CFA1', textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button
            onClick={(): void => {
              if (itemToDelete) {
                deleteLease(itemToDelete.id);
              }
              setDeleteDialogOpen(false);
              setItemToDelete(null);
            }}
            style={{ textTransform: 'none', color: 'white', background: '#DC2626' }}
            variant='contained'
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
